var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMusicNoteNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86879 8.8126C9.28319 8.1192 9.55808 7.2422 9.61142 6.37443C9.64527 5.81745 9.52116 5.23279 9.25241 4.68299C8.83084 3.81932 8.10667 3.33415 7.40712 2.86539C6.88503 2.51562 6.39165 2.18533 6.0429 1.71349L5.98033 1.62938C5.77416 1.35243 5.54132 1.03856 5.50439 0.774946C5.46746 0.508255 5.22539 0.318494 4.96075 0.33388C4.69201 0.352343 4.48379 0.574928 4.48379 0.844696V9.98399C4.05401 9.72345 3.52473 9.56344 2.94519 9.56344C1.53173 9.56344 0.380859 10.4835 0.380859 11.6149C0.380859 12.7463 1.53173 13.6664 2.94519 13.6664C4.35865 13.6664 5.50952 12.7463 5.50952 11.6149V5.63693C6.27984 5.93131 7.54047 6.68112 7.88717 8.43205C7.82254 8.52744 7.761 8.63002 7.6892 8.71208C7.50149 8.9244 7.522 9.24854 7.73536 9.43522C7.94666 9.62395 8.27079 9.60139 8.4585 9.38906C8.59595 9.23315 8.71801 9.05057 8.83494 8.85978C8.84725 8.84542 8.85857 8.83004 8.86879 8.8126Z",
    fill: "#26242B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMusicNoteNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-music-note-new.90a49920b272ff9287d57b63a8d49407.svg";